import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=fe79f13c"
import script from "./changelog.vue?vue&type=script&lang=js"
export * from "./changelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports